import { EventDrivenStore } from '@core/store';
import { EVENTS } from './constants';

class TicketStore extends EventDrivenStore {
  constructor() {
    super('tickets', {
      tickets: [],
      currentTicket: null,
      categories: [],
      filters: {
        category: null,
        dateRange: null,
        priceRange: null,
        location: null,
        query: ''
      },
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        hasMore: false
      },
      favorites: [],
      loading: false,
      error: null
    }, {
      useLocalStorage: true
    });
  }

  setupEvents() {
    // Fetch tickets
    this.on(EVENTS.TICKETS.FETCH, (params) => {
      this.updateState({ loading: true, error: null });
    });

    // Fetch success
    this.on(EVENTS.TICKETS.FETCH_SUCCESS, (data) => {
      this.updateState({
        tickets: data.tickets || [],
        pagination: data.pagination || this.state.pagination,
        loading: false
      });
    });

    // Fetch error
    this.on(EVENTS.TICKETS.FETCH_ERROR, (error) => {
      this.updateState({
        loading: false,
        error: error
      });
    });

    // Fetch by ID success
    this.on(EVENTS.TICKETS.FETCH_BY_ID_SUCCESS, (ticket) => {
      this.updateState({
        currentTicket: ticket
      });
    });

    // Update filters
    this.on(EVENTS.TICKETS.UPDATE_FILTERS, (filters) => {
      const newFilters = { ...this.state.filters, ...filters };
      this.updateState({ filters: newFilters });
      this.emit(EVENTS.TICKETS.FETCH, newFilters);
    });

    // Category changed
    this.on(EVENTS.TICKETS.CATEGORY_CHANGED, (categoryId) => {
      const filters = {
        ...this.state.filters,
        category: categoryId === 'all' ? null : categoryId
      };
      this.updateState({ filters });
      this.emit(EVENTS.TICKETS.FETCH, filters);
    });

    // Toggle favorite
    this.on(EVENTS.TICKETS.TOGGLE_FAVORITE, (ticketId) => {
      const favorites = [...this.state.favorites];
      const index = favorites.indexOf(ticketId);

      if (index > -1) {
        favorites.splice(index, 1);
        this.emit(EVENTS.TICKETS.FAVORITE_REMOVED, ticketId);
      } else {
        favorites.push(ticketId);
        this.emit(EVENTS.TICKETS.FAVORITE_ADDED, ticketId);
      }

      this.updateState({ favorites });
    });

    // Categories loaded
    this.on(EVENTS.TICKETS.CATEGORIES_LOADED, (categories) => {
      this.updateState({ categories });
    });
  }
}

export default TicketStore;
